import numeral from 'numeral';

export const formatLimit = (number, config = {}) => {
  const suffix = !!config.unit === false ? '원' : config.unit;
  if (number === -1) {
    return '제한 없음';
  } else if (number == null) {
    return `0${suffix}`;
  } else {
    return Number.isFinite(number)
      ? numeral(number).format(config.format) + suffix
      : '';
  }
};

// -1을 무제한으로 취급하지 않는 함수
export const formatNormal = (number, config = {}) => {
  const suffix = !!config.unit === false ? '원' : config.unit;
  if (!number) {
    return `0${suffix}`;
  } else {
    return Number.isFinite(number)
      ? numeral(number).format(config.format) + suffix
      : '';
  }
};

// amount
export const sanitize = v => Number(v.replace(/[^\d]/g, ''));

// number and hyphen
export const sanitizeNumberHyphen = v => v.replace(/[^\d-]/g, '');

// only number
export const sanitizeNumber = v => v.replace(/[^\d]/g, '');

// 천단위 구분기호(,) 사용
export const formatNumberWithCommas = v => {
  if (v === null || v === undefined) return '';
  return new Intl.NumberFormat().format(v);
};
